export enum SortChangeHistoryBy {
  ValidityStart = 'ValidityStart',
  ValidityEnd = 'ValidityEnd',
  Changed = 'Changed',
  ChangedBy = 'ChangedBy',
}
